import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VehiclesPageComponent } from './vehicles-page.component';
import { VSpecService } from '../../services/api/vspec.service';
import { DealerDetailService } from '../../services/api/dealer-detail.service';
import { DDFeatureConfigServiceModule } from '../../shared/service/dd-feature-config-service.module';
const vSPecRoutes: Routes = [
  {
    path: '',
    component: VehiclesPageComponent,
    canActivate: []
  }
];

/**
 * define vehicles routing module
 */
@NgModule({
  imports: [
    RouterModule.forChild(
      vSPecRoutes
    ),
    DDFeatureConfigServiceModule.forRoot()
  ],
  exports: [
    RouterModule
  ],
  providers: [
    VSpecService,
    DealerDetailService
  ]
})
export class VehiclesRoutingModule { }
